/**
 * 系统开关配置组件
 * 使用方法详见：src\components\lots\themes\tags_nav\index.vue
 */
const compToggle = {
    render() {
        if (this.disableCodes.length > 0 && this.systemCode && this.disableCodes.includes(this.systemCode)) {
            return '';
        }
        return this.$slots.default;
    },
    data() {
        return {};
    },
    computed: {
        disableCodes() {
            const systemSwitchs = this.$store.getters.systemSwitchs || [];
            return systemSwitchs.filter(i => !i.enabled).map(i => i.resourceCode);
        }
    },
    props: ['systemCode'],
    methods: {
    }
};

export default compToggle;